import CoreModal from "@pages/SupplyChain/components/InventoryOverview/modals/CoreModal";
import { FormInputWrapper } from "@pages/SupplyChain/components/InventoryOverview/modals/CoreModal/FormInputWrapper";
import { FormSelectWrapper } from "@pages/SupplyChain/components/InventoryOverview/modals/CoreModal/FormSelectWrapper";
import React, { useEffect, useState } from "react";
import { WarehouseEnity } from "../../entitys";
import styles from "../styles.module.scss";

interface WarehouseModalProps {
  open: boolean;
  initial?: WarehouseEnity | null;
  onClose: () => void;
  onSubmit: (data: WarehouseEnity, mode: "add" | "edit") => void;
}

const emptyState: WarehouseEnity = {
  name: "",
  type: "",
  country: "",
  address: "",
};

export const WarehouseModal: React.FC<WarehouseModalProps> = ({
  open,
  initial,
  onClose,
  onSubmit,
}) => {
  const [formData, setFormData] = useState<WarehouseEnity>(emptyState);

  useEffect(() => {
    if (open && initial) setFormData(initial);
    if (open && !initial) setFormData(emptyState);
  }, [open, initial]);

  const handleChange = (val: string, name: keyof WarehouseEnity) =>
    setFormData((s) => ({ ...s, [name]: val }));

  const handleOk = () => {
    onSubmit(formData, initial ? "edit" : "add");
  };

  const isValid =
    formData.name.trim() !== "" &&
    formData.type.trim() !== "" &&
    formData.country.trim() !== "";

  return (
    <CoreModal
      open={open}
      title={initial ? "Edit Warehouse" : "Add Warehouse"}
      onCancel={onClose}
      onSave={handleOk}
      disabledButton={!isValid}
    >
      <div className={styles.row}>
        <FormInputWrapper
          label="Name"
          placeholder="Amazon UK main"
          value={formData.name}
          onChange={(value) => handleChange(value, "name")}
        />
        <FormSelectWrapper
          label="Type"
          placeholder="FBA"
          value={formData.type}
          onChange={(value) => handleChange(value, "type")}
          options={[
            { id: "FBA", text: "FBA" },
            { id: "FBM", text: "FBM" },
          ]}
        />
      </div>
      <div className={styles.row}>
        <FormInputWrapper
          label="Country"
          placeholder="UK"
          value={formData.country}
          onChange={(value) => handleChange(value, "country")}
        />
        <FormInputWrapper
          label="Address (optional)"
          placeholder="Long Drive ave. 3, London"
          value={formData.address}
          onChange={(value) => handleChange(value, "address")}
        />
      </div>
    </CoreModal>
  );
};

export default WarehouseModal;
